/** Auth user token key */
export const AUTH_USER_TOKEN_KEY = "token";
export const DATA_UPLOADER_USER_GROUP = "Data-Prep-Factory-Data-Uploaders";
export const DATA_ANNOTATOR_USER_GROUP = "Data-Prep-Factory-Data-Annotator";
export const DATA_VIEWER_USER_GROUP = "Data-Prep-Factory-Data-Viewer";
